import React from 'react';
import { motion } from 'framer-motion';
import { FiTrendingUp, FiClock, FiActivity, FiBarChart2 } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const CallMetrics = () => {
  return (
    <section id="metrics" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-indigo-900/20 blur-[120px] rounded-full pointer-events-none"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-indigo-500 font-bold tracking-widest uppercase text-xs mb-3">Performance Data</h2>
          <h3 className="text-4xl md:text-5xl font-black text-white tracking-tighter mb-4">TRAFFIC DASHBOARD</h3>
          <p className="text-slate-400 text-lg">
            Real-time insights into our network's performance and volume consistency.
          </p>
        </div>

        <div className="bg-slate-900/50 backdrop-blur-xl border border-white/10 rounded-[2.5rem] p-8 md:p-12 shadow-2xl">
          <div className="flex items-center justify-between mb-10 border-b border-white/5 pb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-indigo-500/20 rounded-lg flex items-center justify-center">
                <SafeIcon icon={FiBarChart2} className="text-indigo-400 text-xl" />
              </div>
              <div>
                <h4 className="text-white font-bold">Network Overview</h4>
                <p className="text-slate-500 text-xs">Trailing 30 Days</p>
              </div>
            </div>
            <div className="flex items-center gap-2 px-3 py-1 bg-green-500/10 border border-green-500/20 rounded-full">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-green-400 text-xs font-bold">SYSTEM ACTIVE</span>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Metric 1 */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white/5 border border-white/5 rounded-2xl p-6 relative overflow-hidden"
            >
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-blue-500/10 rounded-full blur-xl"></div>
              <SafeIcon icon={FiTrendingUp} className="text-blue-400 text-2xl mb-4" />
              <div className="text-xs text-slate-400 font-bold tracking-wider mb-1 uppercase">Avg. Intent Score</div>
              <div className="text-4xl font-black text-white">94<span className="text-xl text-slate-500">/100</span></div>
              <div className="mt-4 h-1.5 w-full bg-slate-800 rounded-full overflow-hidden">
                <motion.div 
                  initial={{ width: 0 }}
                  whileInView={{ width: '94%' }}
                  transition={{ duration: 1.5, ease: "easeOut" }}
                  className="h-full bg-blue-500"
                ></motion.div>
              </div>
            </motion.div>

            {/* Metric 2 */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
              className="bg-white/5 border border-white/5 rounded-2xl p-6 relative overflow-hidden"
            >
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-purple-500/10 rounded-full blur-xl"></div>
              <SafeIcon icon={FiClock} className="text-purple-400 text-2xl mb-4" />
              <div className="text-xs text-slate-400 font-bold tracking-wider mb-1 uppercase">Avg. Call Duration</div>
              <div className="text-4xl font-black text-white">4:12<span className="text-xl text-slate-500">m</span></div>
              <div className="mt-4 flex items-center gap-2 text-xs text-purple-400 font-semibold">
                <SafeIcon icon={FiTrendingUp} /> +12% vs last month
              </div>
            </motion.div>

            {/* Metric 3 */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="bg-white/5 border border-white/5 rounded-2xl p-6 relative overflow-hidden"
            >
              <div className="absolute -right-4 -top-4 w-24 h-24 bg-emerald-500/10 rounded-full blur-xl"></div>
              <SafeIcon icon={FiActivity} className="text-emerald-400 text-2xl mb-4" />
              <div className="text-xs text-slate-400 font-bold tracking-wider mb-1 uppercase">Quality Assurance</div>
              <div className="text-4xl font-black text-white">99.2<span className="text-xl text-slate-500">%</span></div>
              <div className="mt-4 h-1.5 w-full bg-slate-800 rounded-full overflow-hidden">
                <motion.div 
                  initial={{ width: 0 }}
                  whileInView={{ width: '99.2%' }}
                  transition={{ duration: 1.5, ease: "easeOut" }}
                  className="h-full bg-emerald-500"
                ></motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallMetrics;